import { BrandLogo } from "../components/brand/BrandLogo";
import { RotatingPattern } from "../components/brand/RotatingPattern";
import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Anchor,
  Button,
  Card,
  Center,
  PasswordInput,
  Stack,
  Text,
  TextInput,
  Title,
  Alert,
} from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import { useAuth } from "../auth/useAuth";
import { errorMessage } from "../lib/axios";

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/", { replace: true });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <Center mih="100vh" p="md" bg="var(--surface-canvas)" pos="relative" style={{ overflow: "hidden" }}>
      <RotatingPattern />
      <Card withBorder shadow="sm" radius="lg" padding="xl" pos="relative" style={{ zIndex: 1 }} w={400} maw="100%">
        <Stack gap="xs" mb="md">
          <BrandLogo height={40} />
          <Title order={4} fw={600}>
            Admin sign in
          </Title>
          <Text c="dimmed" size="sm">
            Operations console — authorized staff only.
          </Text>
        </Stack>

        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            {error && (
              <Alert
                color="red"
                variant="light"
                icon={<IconAlertCircle size={16} />}
              >
                {error}
              </Alert>
            )}
            <TextInput
              label="Email"
              type="email"
              placeholder="you@safiri.tz"
              required
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
              autoFocus
            />
            <PasswordInput
              label="Password"
              placeholder="Your password"
              required
              value={password}
              onChange={(e) => setPassword(e.currentTarget.value)}
            />
            <Button
              type="submit"
              fullWidth
              loading={loading}
              mt="xs"
            >
              Sign in
            </Button>
            <Anchor component={Link} to="/forgot-password" size="sm" ta="center">
              Forgot password?
            </Anchor>
          </Stack>
        </form>
      </Card>
    </Center>
  );
}
